import React from 'react';
import { BotanicalG } from './BotanicalG';
import { ScrollIndicator } from './ScrollIndicator';
export function HeroSection() {
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-109">
      {/* Background Video */}
      <div className="absolute inset-0 z-0" data-id="element-110">
        <video autoPlay muted loop playsInline className="w-full h-full object-cover" data-id="element-111">
          <source src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/GLE%20Website%20Video.mp4" type="video/mp4" data-id="element-112" />
        </video>
        {/* Left-side gradient overlay for text readability — fades to transparent on the right */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-transparent" data-id="element-113"></div>
      </div>

      {/* Content — left-aligned on desktop, centered on mobile */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center lg:items-start text-center lg:text-left w-full lg:w-1/2 px-8 lg:px-20 pt-[160px] lg:pt-[180px]" data-id="element-114">
        {/* Staggered Animations */}
        <div className="animate-fade-in-up [animation-delay:0s] opacity-0 mb-8" data-id="element-115">
          <BotanicalG className="w-24 h-24 md:w-[120px] md:h-[120px]" color="#D4AF37" data-id="element-116" />
        </div>

        <h1 className="animate-fade-in-up [animation-delay:0.3s] opacity-0 md:text-display-tablet lg:text-display-desktop text-white mb-4 drop-shadow-md font-[500]" data-id="element-117">
          Ancient Soils, Pristine Wines
        </h1>

        <h2 className="animate-fade-in-up [animation-delay:0.6s] opacity-0 text-xl md:text-2xl font-medium text-white/90 mb-6 tracking-wide" data-id="element-118">
          Welcome to Glenlofty Estate
        </h2>

        <p className="animate-fade-in-up [animation-delay:0.9s] opacity-0 text-body text-white/85 max-w-2xl mb-10 drop-shadow-sm" data-id="element-119">
          Discover the soul of the Pyrenees in every bottle. From our rugged,
          ancient soils, we craft wines of exceptional elegance, intensity, and
          character.
        </p>

        <div className="animate-fade-in-up [animation-delay:1.2s] opacity-0" data-id="element-120">
          <button className="border border-white bg-transparent text-white px-16 py-4 uppercase tracking-[0.2em] font-medium hover:bg-white hover:text-charcoal hover:-translate-y-[2px] hover:shadow-[0_4px_12px_rgba(0,0,0,0.08)] transition-all duration-300 ease-out" data-id="element-121">
            Explore Our Wines
          </button>
        </div>
      </div>

      <ScrollIndicator data-id="element-122" />
    </section>;
}